import {
  isValidPaymentAmount,
  toPaymentCurrency,
  toStripeDisplayAmount
} from '@elfsight/lib-stripe-integration';
import { toFixedNumber } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { useCalculations } from '../calculations-context';
import { isCalculationEligibleForPayment } from './is-calculation-eligible-for-payment';

export function useProductSourceData() {
  const { checkoutPriceSource, calculations: calculationsSettings } =
    useSettings();
  const calculationsValues = useCalculations();

  if (!checkoutPriceSource) {
    return;
  }

  const calculationData = calculationsSettings.find(
    ({ id }) => id === checkoutPriceSource
  );

  const isCalculationEligible =
    calculationData && isCalculationEligibleForPayment(calculationData);

  if (!isCalculationEligible) {
    return;
  }

  const fixedPriceAmount = Number(
    toFixedNumber(
      Number(calculationsValues[checkoutPriceSource]),
      calculationData.format?.decimalPlaces,
      calculationData.format?.decimalPlaces
    )
  );

  const data = {
    amount: fixedPriceAmount,
    currency: toPaymentCurrency(calculationData.format._currency),
    sourceName: calculationData.name
  };

  // чтобы отображать в точности то значение,
  // которое будет отправляться в страйп для оплаты
  data.amount = toStripeDisplayAmount(data);

  if (!isValidPaymentAmount(data)[0]) {
    return;
  }

  return data;
}
